import { useContext } from "react"
import { DashboardContext } from "./DashboardContext"

export const StudentDash = () => {
  const {
    student,
    setSelectedSemesterId,
    setSelectedCourseId,
    setSelectedExamId,
    selectedSemesterId,
    selectedCourseId,
    selectedExamId,
    exams,
    t,
    semesters,
    courses,
  } = useContext(DashboardContext)
  console.log(exams, "exams------------------------------------------")
  return (
    <div className="card showdow-sm mt-3">
      <div className="card-header">{student?.full_name}</div>
      <div className="card-body">
        <div className="row">
          <div className="col">
            <select
              className="form-control"
              onChange={(e) => {
                setSelectedSemesterId(e.target.value)
                setSelectedCourseId("")
                setSelectedExamId("")
              }}
              value={selectedSemesterId}>
              <option value="">{t("please_select_semester")}</option>
              {semesters.map((semester) => (
                <option key={`semesters-${semester.id}`} value={semester.id}>
                  {semester.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col">
            <select
              className="form-control"
              value={selectedCourseId}
              onChange={(e) => {
                setSelectedCourseId(e.target.value)
                setSelectedExamId("")
              }}>
              <option value={``}>{t("please_select_course")}</option>
              {courses?.map((course) => (
                <option key={`courses-${course.id}`} value={course.id}>
                  {course.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col">
            <select value={selectedExamId} className="form-control" onChange={(e) => setSelectedExamId(e.target.value)}>
              <option value={``}>{t("please_select_exam")}</option>
              {exams?.map((exam) => (
                <optgroup label={exam.exam_group_name ? exam.exam_group_name : "Exam"}>
                  <option key={`courses-${exam.id}`} value={exam.id}>
                    {exam.code}
                  </option>
                </optgroup>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  )
}
